import { Fragment, useEffect, useState } from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import { CommonLoading } from 'react-loadingg';
import { CreateUserForm, CreateUserHeader, DeleteUserForm } from '.';

const CreateUser = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [showEditCreateUser, setShowEditCreateUser] = useState(false);
    const [showEditDeleteUser, setShowEditDeleteUser] = useState(false);
    const [showCreateUserForm, setCreateUserForm] = useState(false);
    const [showDeleteUserForm, setDeleteUserForm] = useState(false);

    const handleCreateUserForm = () => {
        setCreateUserForm(!showCreateUserForm);
        setDeleteUserForm(false);
    };
    const handleDeleteUserForm = () => {
        setDeleteUserForm(!showDeleteUserForm);
        setCreateUserForm(false);
    };

    useEffect(() => {
        if (props.loginList) {
            const loginListFromParent = props.loginList;

            const permit = loginListFromParent.some(
                (item) =>
                    (item.permissionName.includes('Admin Role') &&
                        item.permissionType.includes('view')) ||
                    (item.permissionName.includes(
                        'Create Bus Driver Account'
                    ) &&
                        item.permissionType.includes('view')) ||
                    (item.permissionName.includes(
                        'Delete Bus Driver Account'
                    ) &&
                        item.permissionType.includes('view'))
            );

            if (!permit) {
                window.stop();
                alert('You have no permissions to access this page.');
                window.location = '/';
            } else {
                setIsLoading(false);
            }

            const editCreateUserPermit = loginListFromParent.some(
                (item) =>
                    (item.permissionName.includes('Admin Role') &&
                        item.permissionType.includes('edit')) ||
                    (item.permissionName.includes(
                        'Create Bus Driver Account'
                    ) &&
                        item.permissionType.includes('edit'))
            );

            if (editCreateUserPermit) {
                setShowEditCreateUser(true);
            }

            const editDeleteUserPermit = loginListFromParent.some(
                (item) =>
                    (item.permissionName.includes('Admin Role') &&
                        item.permissionType.includes('edit')) ||
                    (item.permissionName.includes(
                        'Delete Bus Driver Account'
                    ) &&
                        item.permissionType.includes('edit'))
            );

            if (editDeleteUserPermit) {
                setShowEditDeleteUser(true);
            }
        }
    }, [props.loginList]);

    const [busDrivers, setBusDrivers] = useState([]);
    const { REACT_APP_API_BACKEND_URL } = process.env;

    useEffect(() => {
        const getBusDrivers = async () => {
            const busDriversFromServer = await fetchBusDrivers();
            setBusDrivers(busDriversFromServer);
        };

        getBusDrivers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchBusDrivers = async () => {
        const res = await fetch(
            REACT_APP_API_BACKEND_URL + '/api/busdriver/getbusdriverlist'
        );
        const data = await res.json();

        return data;
    };

    const BusDriverList = () => {
        return (
            <>
                {busDrivers.length > 0 ? (
                    <DeleteUserForm busDrivers={busDrivers} />
                ) : (
                    <div style={{ marginTop: '20px', marginLeft: '10px' }}>
                        Please wait...
                    </div>
                )}
            </>
        );
    };

    return (
        <Fragment>
            {isLoading ? (
                <CommonLoading />
            ) : (
                <div className='main-hero-container'>
                    <div
                        className={`${
                            props.isActive ? 'container is-active' : 'container'
                        }`}
                    >
                        <CreateUserHeader />
                        <div
                            className={`${
                                showCreateUserForm
                                    ? 'table-wrapper'
                                    : showDeleteUserForm
                                    ? 'table-wrapper'
                                    : ''
                            } `}
                        >
                            {/* <ButtonGroup className="col-sm-4"> */}
                            <ButtonGroup className='col-sm-8'>
                                {showEditCreateUser && (
                                    <Button
                                        onClick={handleCreateUserForm}
                                        variant={`${
                                            showCreateUserForm
                                                ? 'primary'
                                                : 'outline-primary'
                                        }`}
                                        className='col-sm-3'
                                        style={{ margin: '5px 1px' }}
                                    >
                                        Create Bus Driver
                                    </Button>
                                )}
                                {showEditDeleteUser && (
                                    <Button
                                        onClick={handleDeleteUserForm}
                                        variant={`${
                                            showDeleteUserForm
                                                ? 'primary'
                                                : 'outline-primary'
                                        }`}
                                        className='col-sm-3'
                                        style={{ margin: '5px 0px' }}
                                    >
                                        Delete Bus Driver
                                    </Button>
                                )}
                            </ButtonGroup>
                            {showCreateUserForm && <CreateUserForm />}
                            {showDeleteUserForm && <BusDriverList />}
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default CreateUser;
